import { FeedbackDetailsActionType, Action } from "../Actions/FeedbackDetailsActions";
import { BugReport, FeatureRequest, ResourceRequest } from "../Models/Feedback";

export interface FeedbackDetailsState {
  contentIsLoaded: boolean;
  isLoading: boolean;
  feedback: FeatureRequest | BugReport | ResourceRequest | null;
  hasError: boolean;
  errorCode: number | null;
  errorDescription: string;
}

const initialState: FeedbackDetailsState = {
  contentIsLoaded: false,
  isLoading: false,
  feedback: null,
  hasError: false,
  errorCode: null,
  errorDescription: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const feedbackDetailsReducer = (
  state: FeedbackDetailsState = initialState,
  action: Action<any>
) => {
  switch (action.type) {
    case FeedbackDetailsActionType.SET_FEEDBACK_DETAILS:
      return updateObject(state, {
        feedback: action.payload,
        contentIsLoaded: true,
        isLoading: false
      });
    case FeedbackDetailsActionType.SET_LOADING:
      return updateObject(state, {
        isLoading: true,
        contentIsLoaded: false
      });
    case FeedbackDetailsActionType.RESET_LOADING:
      return updateObject(state, {
        isLoading: false,
        hasError: false,
        errorCode: "",
        errorDescription: ""
      });
    case FeedbackDetailsActionType.UPDATE_LOADED_FEEDBACK_DETAILS:
      return updateObject(state, {
        feedback: action.payload
      });
    case FeedbackDetailsActionType.RESET_LOADED:
      return updateObject(state, {
        contentIsLoaded: false
      });
    case FeedbackDetailsActionType.SET_ERROR:
      return updateObject(state, {
        hasError: true,
        errorCode: action.payload.errorCode,
        errorDescription: action.payload.errorDescription
      });
    default:
      return state;
  }
};

export default feedbackDetailsReducer;
